import { createApp } from 'vue'
import Radyan from './Radyan.vue'
import './assets/global.css'

createApp(Radyan).mount('#radyan')
